import { Component } from '@angular/core';
import { AvailabilityModalComponent } from 'gung-standard';

/**
 * How much of each availability bucket the customer only has because their own block orders were released. Written by
 * JeevesBlockOrderTransformer when gung.block-orders.jeeves.expose-released-quantity is on, and only for the buckets the
 * release actually changed - so it is absent for everyone else and the breakdown renders unchanged.
 */
const BLOCK_RESERVED_BY_DATE_KEY = '_blockReservedByDate';

@Component({
    selector: 'gung-jeeves-jeeves-availability-modal',
    templateUrl: './jeeves-availability-modal.component.html',
    styleUrl: './jeeves-availability-modal.component.css',
    standalone: false
})
export class JeevesAvailabilityModalComponent extends AvailabilityModalComponent {

  /**
   * The part of the figure shown for this date that comes from the customer's own block orders, or 0. The same released
   * quantity is carried forward by every later bucket, so these are not additive across rows - each one decomposes its
   * own row.
   */
  reservedOn(date: string): number {
    return this.availability?.extra?.[BLOCK_RESERVED_BY_DATE_KEY]?.[date] || 0;
  }

  /** What the figure for this date would have been without the customer's own block orders. */
  availableWithoutReservedOn(date: string, value: number): number {
    return value - this.reservedOn(date);
  }

}
